import { TooltipV2 } from '@cimplico/components';
import {
    FolderMinusIcon,
    FolderIcon,
    DocumentIcon,
    LinkIcon,
    DocumentMagnifyingGlassIcon,
    LockClosedIcon,
} from '@heroicons/react/20/solid';
import { FileRecordTypeEnum } from '../../types/file-record';
import { isFolderType } from './file-utils';

function RecordTypeIcon({
    recordType,
    system,
    locked,
}: {
    recordType: FileRecordTypeEnum;
    system?: boolean;
    locked?: boolean;
}): JSX.Element {
    if (isFolderType(recordType)) {
        return system ? (
            <div className="flex items-center">
                <TooltipV2 position="left" message="System Folder">
                    <FolderMinusIcon className="text-gray-700 h-5 w-5" />
                </TooltipV2>
                {locked && (
                    <TooltipV2 position="right" message="This folder is locked">
                        <LockClosedIcon className="text-gray-700 h-4 w-5 ml-1" />
                    </TooltipV2>
                )}
            </div>
        ) : (
            <TooltipV2 position="left" message="Custom Folder">
                <FolderIcon className="text-gray-700 h-5 w-5" />
            </TooltipV2>
        );
    }
    if (recordType === FileRecordTypeEnum.DOCUMENT) {
        return (
            <div className="flex items-center">
                <TooltipV2 position="left" message="Document">
                    <DocumentIcon className="text-gray-700 h-5 w-5" />
                </TooltipV2>
                {locked && (
                    <TooltipV2 position="right" message="This is locked">
                        <LockClosedIcon className="text-gray-700 h-4 w-5 ml-1" />
                    </TooltipV2>
                )}
            </div>
        );
    }
    if (recordType === FileRecordTypeEnum.LINK) {
        return (
            <div className="flex items-center">
                <TooltipV2 position="left" message="External Link">
                    <LinkIcon className="text-gray-700 h-5 w-5" />
                </TooltipV2>
                {locked && (
                    <TooltipV2 position="right" message="This is locked">
                        <LockClosedIcon className="text-gray-700 h-4 w-5 ml-1" />
                    </TooltipV2>
                )}
            </div>
        );
    }
    if (recordType === FileRecordTypeEnum.FYI_DOCUMENT) {
        return (
            <div className="flex items-center">
                <TooltipV2 position="left" message="FYI Document">
                    <DocumentIcon className="text-gray-700 h-5 w-5" />
                </TooltipV2>
                {locked && (
                    <TooltipV2 position="right" message="This is locked">
                        <LockClosedIcon className="text-gray-700 h-4 w-5 ml-1" />
                    </TooltipV2>
                )}
            </div>
        );
    }
    return (
        <div className="flex items-center">
            <TooltipV2 position="left" message="Document Reference">
                <DocumentMagnifyingGlassIcon className="text-gray-700 h-5 w-5" />
            </TooltipV2>
            {locked && (
                <TooltipV2 position="right" message="This is locked">
                    <LockClosedIcon className="text-gray-700 h-4 w-5 ml-1" />
                </TooltipV2>
            )}
        </div>
    );
}
export default RecordTypeIcon;
